import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { useLogin } from '../context/LoginContext'
import { usePerson } from '../context/PersonContext'

import TitleBox from '../components/common/TitleBox';
import Button from '../components/common/Button';
import { IconPlus } from '../components/icons/Icons';
import Modal from '../components/common/Modal';
import ContainerBox from '../components/common/ContainerBox';
import TableData from '../components/common/TableData';
import PersonsForm from '../components/forms/PersonsForm';

const PersonasPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [idPerson, setIdPerson] = useState(null);
  const navigate = useNavigate()
  const { user } = useLogin();
  const MySwal = withReactContent(Swal)
  const {
    modal,
    persons,
    getPersons,
    getModal,
    deletePerson
  } = usePerson();

  useEffect(() => {
    if (user !== null) {
      navigate('/personas')
    }
    getPersons()
  }, [user])

  const openModal = (id = null) => {
    setIsModalOpen(true);
    setIdPerson(id)
    getModal()
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleDeletePerson = (id) => {
    MySwal.fire({
      title: '¿Está seguro?',
      text: "¡No podrás revertir esto!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn-alert-primary',
        cancelButton: 'btn-alert-danger',
        title: 'title-alert',
        htmlContainer: 'text-alert'
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deletePerson(id)
        if (response.status === 204) {
          MySwal.fire({
            title: '¡Eliminado!',
            text: response.msg,
            icon: 'success',
            customClass: {
              confirmButton: 'btn-alert-primary',
              cancelButton: 'btn-alert-danger',
              title: 'title-alert',
              htmlContainer: 'text-alert'
            },
          })
        } else {
          MySwal.fire({
            title: '¡Error!',
            text: response.msg,
            icon: 'error',
            customClass: {
              confirmButton: 'btn-alert-primary',
              cancelButton: 'btn-alert-danger',
              title: 'title-alert',
              htmlContainer: 'text-alert'
            },
          })
        }
      }
    })
  }


  const columns = [
    {
      header: '#',
      cell: ({ cell }) => {
        const { row } = cell;
        return <div>{row.index + 1}</div>
      }
    },
    {
      header: 'Nombre',
      accessorKey: 'name'
    },
    {
      header: 'Nro.documento',
      accessorKey: 'document'
    },
    {
      header: 'Email',
      accessorKey: 'email'
    },
    {
      header: 'Teléfono',
      accessorKey: 'phone'
    },
    {
      header: 'Acciones',
      cell: ({ cell }) => {
        const id = cell.row.original.id
        return <div className='flex items-center'>
          <button
            className="bg-warning/50 hover:bg-warning/60 border border-warning/20 text-xs text-black/50 px-3 py-1 rounded-sm"
            onClick={() => openModal(id)}
          >
            Editar
          </button>
          <button
            className="bg-danger/20 hover:bg-danger/30 border border-danger/20 text-xs text-danger px-3 py-1 rounded-sm"
            onClick={() => handleDeletePerson(id)}
          >
            Eliminar
          </button>
        </div>
      }
    }
  ];

  return (
    <>
      <TitleBox title='Maestro personas de sistema' />
      <ContainerBox>
        <Button value='Nuevo' openModal={() => openModal()}>
          <IconPlus className='w-4' />
        </Button>
        <TableData columns={columns} data={persons} />
      </ContainerBox>
      <Modal isOpen={isModalOpen} onClose={closeModal} isModal={modal} title={"Nueva persona"}>
        <PersonsForm person={idPerson} />
      </Modal>
    </>
  )
}

export default PersonasPage